import React, { FC } from 'react';
import { Tag as AntTag } from 'antd';
import { TagProps } from 'antd/lib/tag';

export const Tag: FC<TagProps> = (props) => {
  return <AntTag {...props} />;
};
export default Tag;
